module.exports = {"pathContext":{"name":"IguanaRisOrderUpdateStatus","kind":"ENUM","type":"OBJECT","fields":null,"description":null,"enumValues":[{"deprecationReason":null,"description":null,"isDeprecated":false,"name":"COMPLETED"},{"deprecationReason":null,"description":null,"isDeprecated":false,"name":"INPROGRESS"}],"possibleTypes":null}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/enum-iguana-ris-order-update-status.json
// module id = 1251
// module chunks = 225211428462577